<template>
    <v-chip
        color="success black--text"
        outlined
        large
    >
        <span class="black--text">This is your {{ isMatcher ? 'transfer' : 'offer' }}</span>
        <v-btn
            color="success"
            class="ml-2"
            depressed
            x-small
            fab
        >
            <v-icon>
                mdi-medal-outline
            </v-icon>
        </v-btn>
    </v-chip>
</template>

<script>
    export default {
        props: {
            isMatcher: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
